<div #feedback id="feedback-section" role="alert" class="alert alert-warning" style="text-align:left;">
  Attention! Once your item(s) have been added to your cart you will have 30 minutes to check out. If you do not check out within 30 minutes, the items will be removed and sent back to available.
</div>

<form [formGroup]="form" (ngSubmit)="addToCart()" class="form">
  <kendo-stacklayout orientation="vertical" [align]="{ vertical: 'top' }">
    <kendo-stacklayout orientation="horizontal" [style.height.px]="300">
      <div class="box content">
        <div class="demo">
          <kendo-scrollview [data]="items"
                            [width]="width"
                            [pagerOverlay]="'dark'"
                            [height]="height"
                            [arrows]="true"
                            [pageable]="true">
            <ng-template let-item="item">
              <h2 class="demo-title">{{ item.title }}</h2>
              <img src="{{ item.image }}"
                   alt="{{ item.name }}"
                   draggable="false" />
            </ng-template>
          </kendo-scrollview>
        </div>
      </div>
      <div>
        <br />
        <kendo-card class="quantityCard">
          <kendo-card-body>
            <div style="padding: 0px 10px;">
              @if(entity)
              {
                <div class="quantityContainer">
                  <h1>{{entity.title}}</h1>
                  <div>
                    <div style="padding: 0px 10px; text-align: left;">
                      <pre class="descriptionBlock">Quantity: {{ entity.inventoryCount }}</pre>
                      <pre class="descriptionBlock">SKU: {{ entity.sku }}</pre>

                      @if(entity.generateReturnOrder){
                        <div class="returnOrderSection">
                          <div style="text-align: left; padding:5px;">
                            <label>Return Label Required?</label>
                          </div>
                          <div style="text-align: left; padding-bottom:10px;">
                            <input kendoCheckBox
                                   id="isReturnOrder"
                                   type="checkbox"
                                   name="isReturnOrder"
                                   formControlName="isReturnOrder"
                                   (change)="toggleReturnOrder($event)"/>
                          </div>
                        </div>

                        <div id="legalHoldSection" style="display:none;">
                          <div style="text-align: left; padding:5px;">
                            <label>Legal Hold Required?</label>
                          </div>
                          <div style="text-align: left; padding-bottom:10px;">
                            <input kendoCheckBox type="checkbox" name="isLegalHold" formControlName="isLegalHold" />
                          </div>
                        </div>
                      }

                          @if(entity && showAddonOptions == true){

                          <div style="text-align: left; padding:5px;">
                            <label>Add On Options</label>
                          </div>
                          <div style="text-align: left; padding-bottom:10px; width:80%;">
                            <app-select-field [control]="addonOptionId"></app-select-field>
                          </div>
                          }
                        <div style="text-align: left; padding:5px;">
                          <label>Quantity</label>
                        </div>
                        <div style="text-align: left; padding-bottom:10px;">
                          <kendo-numerictextbox id="quantity"
                                                class="form-textbox"
                                                format="n"
                                                [min]="1"
                                                [value]="1"
                                                formControlName="quantity">

                          </kendo-numerictextbox>
                        </div>
                        <button id="addToCartBtn" class="primary" type="submit">ADD TO CART</button>
                      </div>
                      <pre class="descriptionBlock">{{ entity.condition }}</pre>
                      <pre class="descriptionBlock">{{ entity.description }}</pre>
                      <pre class="descriptionBlock">{{ entity.partNumber }}</pre>
                    </div>
                </div>
              }
            </div>
          </kendo-card-body>
        </kendo-card>
      </div>
    </kendo-stacklayout>
  </kendo-stacklayout>
</form>
